import { FileTypes } from '../constants';
export function splitNameAndExtension(fileName) {
  const parts = fileName.split('.');
  if (parts.length === 1) {
    return {
      extension: '',
      name: fileName
    };
  }
  return {
    extension: parts.pop() || '',
    name: parts.join('.')
  };
}
export function isImage(file) {
  return file.type && file.type.startsWith('image/');
}
const NO_LOCAL_PREVIEW_IMAGE_EXTENSIONS = ['svg', 'heic', 'tiff'];
export function canPreviewLocalFile(localFile) {
  const {
    extension
  } = splitNameAndExtension(localFile.name);
  return isImage(localFile) && !NO_LOCAL_PREVIEW_IMAGE_EXTENSIONS.includes(extension.toLowerCase());
}
export function isShutterstockImage(file) {
  return Boolean(file.type === FileTypes.IMG && file.meta.shutterstock_id);
}